import React, { useState, useEffect } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import BoxContainer from '~src/components/BoxContainer';
import Resoconto from '~src/components/Removebg/Resoconto';
import Storico from '~src/components/Removebg/Storico';
import { fetchAiCredits } from '~graphql/controllers/fetchAiCredits';
import { onErrorShowMessage } from '~src/errors';

const Loader = () => (
  <div className="text-center">
    <Spinner animation="grow" variant="info" />
  </div>
);

const ProfilePage = () => {
  const [loadingCredits, setLoadingCredits] = useState(true);
  const [credits, setCredits] = useState({});

  useEffect(() => {
    setLoadingCredits(true);
    fetchAiCredits()
      .then((credits) => {
        if (!credits || !credits.edges || !credits.edges[0]) {
          setCredits({
            freeCreditsAmount: 0,
            paidCreditsAmount: 0,
          });
        } else {
          setCredits(credits.edges[0]);
        }
        setLoadingCredits(false);
      })
      .catch((err) => {
        console.error(err);
        onErrorShowMessage();
      });
  }, []);

  return (
    <Container fluid>
      <BoxContainer
        theme="dark"
        title="Crediti Intelligenza Artificiale"
        spacing={true}
      >
        <p className="lead text-dark text-center">
          Vedi il saldo e come gli strumenti AI stanno aiutando il lavoro sui
          defunti, con uno storico semplice da consultare.
        </p>

        <BoxContainer
          xsColSize={12}
          xsColOffset={0}
          smColSize={12}
          smColOffset={0}
          lgColSize={10}
          lgColOffset={1}
          theme="light"
          className="ai-credits-history"
        >
          {loadingCredits ? (
            <div className="ai-credits-history__summary ai-credits-history__summary--loading">
              <Loader />
            </div>
          ) : (
            <Resoconto credits={credits} />
          )}

          <div className="ai-credits-history__section-divider"></div>
          <Storico />
        </BoxContainer>
      </BoxContainer>
    </Container>
  );
};

export default ProfilePage;
